import { render, staticRenderFns } from "./AltaBase.vue?vue&type=template&id=7bcac42a&scoped=true&"
import script from "./AltaBase.vue?vue&type=script&lang=js&"
export * from "./AltaBase.vue?vue&type=script&lang=js&"
import style0 from "./AltaBase.vue?vue&type=style&index=0&id=7bcac42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcac42a",
  null
  
)

export default component.exports